const c = {
  name: "UaeDirham",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill-rule:evenodd;clip-rule:evenodd;fill: currentColor;}
	.st1{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M11.5,21.3c-0.1-0.3-0.1-0.5-0.1-0.8l-0.5,0c0,0.3-0.1,0.6-0.1,0.9c0,1.9,1,2.7,2.5,2.7
			c1.3-0.1,2.5-0.5,3.6-1.2c0.3-0.7,0.5-1.5,0.5-2.3c-0.1-1.1-0.5-2.2-1.3-3.1c-0.9-1.1-1.9-2-3.1-2.7h-0.1
			c-0.3,0.4-0.5,0.9-0.7,1.4c0,0.1,0.1,0.3,0.4,0.5c1,0.5,1.9,1.2,2.6,2c0.7,0.7,1.1,1.5,1.2,2.4c0,0.1-0.1,0.2-0.3,0.3
			c-0.8,0.5-1.8,0.8-2.8,0.8c-0.3,0-0.6,0-0.8-0.1c-0.3-0.1-0.5-0.2-0.7-0.4C11.7,21.8,11.6,21.6,11.5,21.3z"/>
		<path class="st0" d="M20.5,21.2h2.1V24h-2.1V21.2z"/>
		<path class="st1" d="M29.2,27.3C29.2,27.2,29.2,27.2,29.2,27.3L29.2,27.3L29.2,27.3z"/>
		<path class="st0" d="M28.7,28c0.2-0.2,0.3-0.5,0.5-0.8h-1.2c-0.8,0-1.9-0.2-1.9-0.8c0-0.2,0.5-0.4,0.9-0.4c0.1,0,0.3,0,0.4,0
			c0.1,0,0.3,0.2,0.4,0.5c0.2-0.2,0.4-0.5,0.4-0.8c0-0.3-0.3-0.6-0.8-0.6c-0.6,0.1-1.1,0.4-1.5,0.8c-0.3,0.3-0.6,0.7-0.6,1.1
			c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.4c-0.2,0.1-0.4,0.2-0.6,0.4L25.4,29C26.4,28.6,27.5,28.2,28.7,28z"/>
		<path class="st0" d="M26.7,21.7c0,0.9,0,1.7-0.1,2.6l0.2,0c0.6-0.5,1-1.3,1.1-2.1c0.1-0.6,0.1-1.3,0.1-2.1c0-3-0.1-6.3-0.3-9.1
			h-0.1c-0.5,0.4-0.9,0.9-1.3,1.4c0.2,2.2,0.5,5.6,0.5,8V21.7z"/>
		<path class="st0" d="M5.9,5.9C9.6,2.1,14.7,0,20,0c5.3,0,10.4,2.1,14.1,5.9S40,14.7,40,20c0,2.6-0.5,5.2-1.5,7.7
			c-1,2.4-2.5,4.6-4.3,6.5c-1.9,1.9-4.1,3.3-6.5,4.3c-2.4,1-5,1.5-7.7,1.5c-5.3,0-10.4-2.1-14.1-5.9c-1.9-1.9-3.3-4.1-4.3-6.5
			c-1-2.4-1.5-5-1.5-7.7C0,14.7,2.1,9.6,5.9,5.9z M7.3,32.7c3.4,3.4,8,5.3,12.7,5.3c2.4,0,4.7-0.5,6.9-1.4c2.2-0.9,4.2-2.2,5.8-3.9
			c1.7-1.7,3-3.7,3.9-5.8c0.9-2.2,1.4-4.5,1.4-6.9c0-4.8-1.9-9.4-5.3-12.7C29.4,3.9,24.8,2,20,2S10.7,3.9,7.3,7.3
			C3.9,10.6,2,15.2,2,20S3.9,29.4,7.3,32.7z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as UaeDirham
};
